module.exports = __webpack_public_path__ + "static/img/b3-2.01d01bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b3-2.png
// module id = j83m
// module chunks = 1